import box from 'assets/images/psp/Portable-storage/box.svg';
import construction from 'assets/images/psp/Portable-storage/construction.svg';
import events from 'assets/images/psp/Portable-storage/events.svg';
import home from 'assets/images/psp/Portable-storage/home.svg';
import moving from 'assets/images/psp/Portable-storage/moving.svg';
import seosonal from 'assets/images/psp/Portable-storage/seasonal.svg';
import tool from 'assets/images/psp/Portable-storage/tool.svg';
import valuable from 'assets/images/psp/Portable-storage/valuable-apparel.svg';
import shop from 'assets/images/psp/Portable-storage/shop.svg';
import short from 'assets/images/psp/Portable-storage/short-term.svg';
import portable8ft from 'assets/images/psp/Portable-storage/8ft.svg';
import portable12ft from 'assets/images/psp/Portable-storage/12ft.svg';
import portable16ft from 'assets/images/psp/Portable-storage/16ft.svg';
import portableContentImage from 'assets/images/content-section/Illustration-Truck-Boat-Car.svg';
import PortableStorage1 from 'assets/images/psp/FeaturedImages/portable1.webp';
import PortableStorage2 from 'assets/images/psp/FeaturedImages/portable2.webp';
import PortableStorage3 from 'assets/images/psp/FeaturedImages/portable3.webp';
import PortableStorage4 from 'assets/images/psp/FeaturedImages/portable4.webp';
import TruckMover from 'assets/images/psp/Truck/illustration-truck-and-mover.webp';

const faqs = [
	{
		question:
			'Is it cheaper to rent PODS storage units or standard storage units?',
		answer:
			'It depends on your specific needs. For **short-term storage (1–3 months)**, portable storage costs more upfront but saves money on **truck rentals, gas, and time**. ' +
			'When you factor in the **convenience** of having the container at your location, no transportation costs, and unlimited access, portable storage often provides better overall value.\n\n' +
			'For **long-term storage (6+ months)**, traditional storage units are usually more economical.',
	},
	{
		question: 'How much does portable or mobile storage cost?',
		answer:
			'Portable storage costs vary by **container size**, **location**, and **rental duration**.\n\n' +
			'- **Local moves:** $225–$850\n' +
			'- **Long-distance moves:** $450–$7,600 (depending on distance)\n\n' +
			'**Monthly rates:**\n' +
			'- Small (8-foot): around $150/month\n' +
			'- Medium (12-foot): $175–$225/month\n' +
			'- Large (16-foot): $200–$300/month\n\n' +
			'Many companies offer **package deals** that include the first month and delivery, making it easier to budget for your storage needs.',
	},
	{
		question: 'Will my portable storage container come with a lock?',
		answer:
			"Most portable storage companies do not provide locks — [you'll need to supply your own high-quality padlock or disc lock for security](https://www.sparefoot.com/blog/all-about-self-storage-locks). " +
			'This gives you complete control over access to your belongings.\n\n' +
			'Companies like **PODS** and **1-800-PACK-RAT** specifically require customers to provide their own locks. ' +
			'We recommend using a **heavy-duty, weather-resistant padlock or disc lock** designed for outdoor use.\n\n' +
			'Some companies sell lock accessories, but bringing your own ensures you have the only keys. ' +
			'Always use a quality lock since your container will be outdoors and exposed to both weather and potential theft.',
	},
	{
		question: 'Can I store my car in a portable storage unit?',
		answer:
			'Most portable storage containers are not suitable for vehicle storage due to size and weight limitations.\n\n' +
			'- Standard 8-foot and 12-foot containers are too small for most cars.\n' +
			'- Even 16-foot containers often lack sufficient width.\n' +
			'- Containers typically have **weight limits (4,000–6,000 lbs)**, which a car plus belongings could exceed.\n\n' +
			'They also sit low to the ground without proper ramps for driving vehicles inside.\n\n' +
			'For [vehicle storage](https://www.sparefoot.com/car-storage.html), consider **traditional storage facilities** with **drive-up units** or **covered parking options** specifically designed for cars, RVs, and boats.',
	},
	{
		question: 'Can I live in my mobile storage unit?',
		answer:
			'No, you [cannot live in a portable storage container](https://www.sparefoot.com/blog/how-common-is-living-in-a-storage-unit). These units are designed only for storing belongings and are **not suitable for human habitation**.\n\n' +
			'They lack proper ventilation, insulation, plumbing, electrical systems, and safety features required for living spaces. Most rental agreements explicitly prohibit using containers as living quarters, and doing so would violate local zoning laws and building codes. Additionally, portable storage containers are not weatherproofed for human comfort and can become extremely hot or cold.',
	},
];

const videoDescription = [
	'Portable storage is the ultimate storage hack for those who need to maximize flexibility without sacrificing security and weatherproofing. You might have seen a storage container with wheels in a neighbor’s yard before a big move, or maybe a steel mini mobile storage container or two on a construction site. Those are portable storage solutions: secure portable storage units that come in a variety of sizes to meet the needs of your move, renovations, and accessibility requirements.\n\n',
	'Larger than a portable storage closet, ranging from 7-16 feet long, portable storage units can be parked outside your door, so you can load them up and unpack them at your convenience. The best part? When you’re ready to move your portable storage container, you can have it picked up and transported to its next destination whenever you want.',
];

export const PortableStorageContent = {
	type: 'Portable',
	sections: [
		{
			title: 'Popular Portable Storage Options',
			noPaddingTop: true,
			modules: [
				{
					type: 'PortableStorageComparison',
					props: {
						isPSP: true,
					},
				},
			],
		},
		{
			title: 'video content',
			background: 'yellow',
			modules: [
				{
					title: 'Portable Storage Content',
					type: 'content',
					props: {
						title: 'What is Portable Storage?',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: TruckMover,
						content: videoDescription,
					},
				},
			],
		},
		{
			title: 'Content section - single column',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Size Storage Container Do I Need? ',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						contentImage: portableContentImage,
						content: [
							'The size of portable moving containers differs from your traditional stationary storage unit. Movable storage units need to be large enough to comfortably store a room’s worth of stuff, to more than 3 rooms’ worth of stuff - but small enough to be loaded onto a truck and moved. This means that you’re likely to find your mobile storage container in three standard sizes. ',
						],
					},
				},
			],
		},

		{
			title: 'Portable Storage Sizes',
			noPaddingBottom: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Mobile Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Here’s a quick rundown of mobile storage unit sizes and what they can hold. For more information and help figuring out what size storage container you’ll need, the [SpareFoot size guide](https://www.sparefoot.com/storage-unit-size-guide.html) can help you dig deep. ',
						],
					},
				},
				{
					type: 'unitList',
					props: {
						unitsData: [
							{
								image: portable8ft,
								content:
									'**8-foot**\n\n' +
									'Sometimes referred to as mini mobile storage containers.\n\n' +
									"**Suitable for**: 1-2 rooms' worth of stuff\n\n" +
									'**Maximum weight**: around 4,000lbs.',
							},
							{
								image: portable12ft,
								content:
									'**12-foot**\n\n' +
									'Similar to a 10x10 storage unit\n\n' +
									"**Suitable for**: 2-3 bedrooms' worth of stuff\n\n" +
									'**Maximum weight**: around 6,000lbs.',
							},
							{
								image: portable16ft,
								content:
									'**16-foot**\n\n' +
									'Largest option available from many portable storage facilities\n\n' +
									"**Suitable for**: 3-4 bedrooms' worth of stuff\n\n" +
									'**Maximum weight**: around 6,000lbs.',
							},
						],
					},
				},
			],
		},

		{
			title: 'Content section - single column',
			noPaddingBottom: true,
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Who Should Look for Portable Storage Containers to Buy or Rent?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Storage containers with wheels and mobile storage units provide the safety and security of a traditional storage unit, with the added flexibility of being transported. This makes portable storage units a great option for those packing up for a long-distance move, stowing things away from a renovation, or even families going through a massive spring cleaning exercise.\n\n ',
							'Here’s a short list of situations where renting portable storage near you may be the solution to your logistical problems:',
						],
					},
				},
				{
					type: 'unitList',
					props: {
						unitsData: [
							{
								image: moving,
								content: 'Long-distance moves',
							},
							{
								image: home,
								content: 'Renovations/remodeling',
							},
							{
								image: construction,
								content:
									'Overflow storage on construction sites',
							},
							{
								image: short,
								content: 'Short-term storage needs',
							},
							{
								image: box,
								content:
									'Relocating large quantities of valuables or oversized items',
							},
							{
								image: seosonal,
								content: 'Seasonal storage',
							},
							{
								image: valuable,
								content:
									'Oversized personal, portable storage closet',
							},
							{
								image: shop,
								content:
									'Business inventory storage and management',
							},
							{
								image: events,
								content: 'Event planning',
							},
							{
								image: events,
								content: 'Document storage',
							},
							{
								image: tool,
								content:
									'Portable tool storage for large collections and their accessories',
							},
						],
					},
				},
			],
		},

		{
			title: 'Content section - triple column',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'How Portable Storage Works',
						contentType: 'row-type',
						content: [
							'Portable storage is simple, convenient, and easy to use. SpareFoot works with the nation’s biggest secure portable storage providers and put together this handy guide for working with the supplier of your choice.\n\n',
						],
					},
				},
			],
		},

		{
			title: 'Portable Storage Comparison',
			modules: [
				{
					type: 'content',
					noPaddingBottom: false,
					props: {
						title: 'What Does a Portable Storage Unit Cost? ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Portable storage prices are based on the size of the movable unit that you need, as well as other factors including: moving distance, short-to-long-term storage requirements, seasonality, and vendor.\n',
							'While the monthly rate of portable storage unit costs is listed, other fees may be applied to your final invoice. Some companies charge additional fees for delivery and pickup, insurance, and set-up or other administrative fees.',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'portable-storage-pricing',
						headers: [
							{
								label: 'Service',
								key: 'Service',
							},
							{
								label: 'Container Size',
								key: 'Container Size',
							},
							{
								label: 'Monthly Cost',
								key: 'Monthly Cost',
							},
							{
								label: 'Notes',
								key: 'Notes',
							},
						],
						rows: [
							{
								Service: 'Monthly Storage Only',
								'Container Size': 'Small (8ft)',
								'Monthly Cost': '$80 - $150',
								Notes: 'On-site storage at your location',
							},
							{
								Service: 'Monthly Storage Only',
								'Container Size': 'Medium (12ft)',
								'Monthly Cost': '$120 - $200',
								Notes: 'On-site storage at your location',
							},
							{
								Service: 'Monthly Storage Only',
								'Container Size': 'Large (16ft)',
								'Monthly Cost': '$160 - $250',
								Notes: 'On-site storage at your location',
							},
							{
								Service: 'Local Moving',
								'Container Size': 'Any Size',
								'Monthly Cost': '$225 - $850',
								Notes: 'Includes delivery, pickup, and local transport',
							},
							{
								Service: 'Long-Distance Moving',
								'Container Size': 'Any Size',
								'Monthly Cost': '$450 - $7,600',
								Notes: 'Varies significantly by distance',
							},
							{
								Service: 'Storage at the Facility',
								'Container Size': 'Any Size',
								'Monthly Cost': '$165 - $310',
								Notes: 'The container is stored at the company facility',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'*Prices vary significantly by location, season, and specific company. Contact providers for exact quotes.*\n\n' +
								'#### Additional Fees to Consider:\n\n' +
								'- **Delivery/Pickup Fee**: $95 - $250 per trip\n\n' +
								'- **Transport Fee**: $65 - $250+ for local moves\n\n' +
								'- **Setup Fee**: Often included in first month\n\n' +
								'- **Insurance**: Optional, varies by provider\n\n',
						],
					},
				},
			],
		},

		{
			title: 'Content section - single column',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'We Found You Deals with Popular Portable Storage Companies ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Moving and storage are made easy with portable storage. SpareFoot wants to hook you up with online exclusive deals with some of the most popular names in portable storage. Save up to 10% with our friends at PODS, 1-800-PACK-RAT, and UPack. ',
						],
					},
				},
				{
					type: 'PortableStoragePromoCards',
					props: {
						isPSP: true,
					},
				},
			],
		},

		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Portable Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'portable-featured-content',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'October 24, 2025',
								image: PortableStorage1,
								link: 'https://sparefoot.com/blog/portable-storage-containers',
								content:
									'Portable Storage Containers to the Rescue for Household and Business Needs',
							},
							{
								title: 'General Storage Advice',
								date: 'October 24, 2025',
								image: PortableStorage2,
								link: 'https://sparefoot.com/blog/10-things-to-know-about-portable-storage-containers-before-you-book',
								content:
									'Portable Storage Containers: What You Need to Know Before Booking Your Move or Storage Project',
							},
							{
								title: 'Moving Tips',
								date: 'April 28, 2024',
								image: PortableStorage3,
								link: 'https://sparefoot.com/blog/rental-truck-vs-moving-pods',
								content:
									'Which is Better: Moving Trucks or Portable Storage Containers?',
							},
							{
								title: 'Moving Tips',
								date: 'October 24, 2025',
								image: PortableStorage4,
								link: 'https://sparefoot.com/blog/how-to-pack-pods-for-long-distance-move',
								content:
									'How to Pack a Portable Storage Container For a Long Distance Move',
							},
						],
					},
				},
			],
		},

		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'DriveUp',
							'College',
							'Military',
							'Business',
							'Car',
							'RV',
						],
					},
				},
			],
		},
	],
};
